import { tWithKeyAttr as t } from "../../i18nHelper";
import notFoundStyles from "./notFound.module.css";
import notFoundPic from "../../images/notFound.png";
import { Link } from "react-router-dom";


function NotFoundPage() {
  return (
    <section className={notFoundStyles.section}>
      <h2 className={notFoundStyles.title}>
        {t("NOT_FOUND_PAGE_TITLE")}
      </h2>
      <p className={`${notFoundStyles.text} ${notFoundStyles.text_small}`}>
        {t("NOT_FOUND_PAGE_TEXT_1")}
      </p>
      <p className={notFoundStyles.text}>
        {t("NOT_FOUND_PAGE_TEXT_2")}
      </p>
      <p className={notFoundStyles.text}>
        {t("NOT_FOUND_PAGE_TEXT_3")}
      </p>
      <p className={notFoundStyles.text}>
        {t("NOT_FOUND_PAGE_TEXT_4")}
      </p>
      <img
        src={notFoundPic}
        alt={t("NOT_FOUND_PAGE_IMG_ALT")}
        className={notFoundStyles.img}
      />
      <Link to={"/main"} className={`button hover ${notFoundStyles.link}`}>
        {t("NOT_FOUND_PAGE_HOME_LINK")}
      </Link>
      <p className={notFoundStyles.text}>
        {t("NOT_FOUND_PAGE_TEXT_5")}
      </p>
      <article className={notFoundStyles.footer}>
        <h4 className={notFoundStyles.footerTitle}>
          {t("NOT_FOUND_PAGE_FOOTER_TITLE")}
        </h4>
        <p className={notFoundStyles.footerText}>
          {t('SUPPORT_HOURS')}</p>
        <p className={notFoundStyles.footerText}>
          {t("NOT_FOUND_PAGE_FOOTER_TEXT_3")}
        </p>
        <p className={notFoundStyles.footerText}>
          {t("NOT_FOUND_PAGE_FOOTER_TEXT_4")}
        </p>
        <p className={notFoundStyles.footerText}>
          {t('SUPPORT_URGENT_PHONE')}</p>
      </article>
    </section>
  );
}

export default NotFoundPage;
